import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});

export async function getReferences(params?: { query?: string; perPage?: number; pageNo?: number }) {
  try {
      const queryParams = new URLSearchParams();
      if (params?.query) {
          queryParams.append('query', params.query);
      }
      if (params?.perPage !== undefined) {
          queryParams.append('perPage', params.perPage.toString());
      }
      if (params?.pageNo !== undefined) {
          queryParams.append('pageNo', params.pageNo.toString());
      }
      
      const url = `${BASE_URL}/control-references/regtech${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      
      const response = await authService.apiCall(url, {
          method: "GET",
          
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          throw new Error("Failed to fetch");
      }
      return data;
  } catch (error: any) {
      throw new Error(error);
  }
}


export async function getCoso(){
    try {
      
      
      const response = await authService.apiCall(`${BASE_URL}/coso`,{method:"GET"});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
    
}

export async function getCobit(){
    try {

      const response = await authService.apiCall(`${BASE_URL}/cobit`,{method:"GET"});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
    
}


export async function getCBE(){
    try {
      const response = await authService.apiCall(`${BASE_URL}/cbe-function`,{method:"GET"});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
    
}


export async function getNIST(){
    try {
      const response = await authService.apiCall(`${BASE_URL}/nist`,{method:"GET"});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
    
}


export async function getISO(){
    try {
     
      const response = await fetch(`${BASE_URL}/iso`,{method:"GET",});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
    
}

export async function getControlByCBE(id: any) {
    try {
    
        const response = await authService.apiCall(`${BASE_URL}/control-cbe/by-cbe?cbe_id=${id}`,
           { method: "GET" });
        if (!response.ok) {
            throw new Error('Failed to fetch data');
        }
        return response.json();
    } catch (error) {
        throw new Error('Failed to fetch data');
    }
}

export async function getControlByISO(id:any){
    try {

      const response = await authService.apiCall(`${BASE_URL}/control-iso/${id}`,{method:"GET"});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();

    } catch (error) {
      throw new Error('Failed to fetch data');
    }
}


export async function getControlByCobit(id:any){
    try {
      const response = await authService.apiCall(`${BASE_URL}/control-cobit/${id}`,{method:"GET"});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();

    } catch (error) {
      throw new Error('Failed to fetch data');
    }
} 


export async function getControlByCoso(id:any){
    try {

      const response = await authService.apiCall(`${BASE_URL}/control-coso/${id}`,{method:"GET"});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();

    } catch (error) {
        throw new Error('Failed to fetch data');
    }
}

export async function getControlByNist(id:any){
    try {

      const response = await authService.apiCall(`${BASE_URL}/control-nist/${id}`,{method:"GET"});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
} 

export async function uploadExcel(file: File) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await authService.apiCall(`${BASE_URL}/domain/upload-template`, {
        method: "POST",
        body: formData,
      });
      
      if (!response.ok) {
        throw new Error('Failed to upload file');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to upload file');
    }
}





















// Domain CRUD operations
export async function createDomain(domainData: any) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/domain`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(domainData),
    });

    if (!response.ok) {
      throw new Error('Failed to create domain');
    }
    return response.json();
  } catch (error) {
    throw new Error('Failed to create domain');
  }
}

export async function updateDomain(id: string, domainData: any) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/domain/${id}`, {
      method: "PATCH",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(domainData),
    });

    if (!response.ok) {
      throw new Error('Failed to update domain');
    }
    return response.json();
  } catch (error) {
    throw new Error('Failed to update domain');
  }
}

export async function deleteDomain(id: string) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/domain/${id}`, {
      method: "DELETE",
    });

    if (!response.ok) {
      throw new Error('Failed to delete domain');
    }
    return response.json();
  } catch (error) {
    throw new Error('Failed to delete domain');
  }
}

export async function getAllDomains() {
  try {
    const response = await authService.apiCall(`${BASE_URL}/domain/getAll`, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error('Failed to fetch domains');
    }
    return response.json();
  } catch (error) {
    throw new Error('Failed to fetch domains');
  }
}



// update control apio
export async function fetchOneControlApi(url: string, options: RequestInit = {}): Promise<any> {
    try {
        const response = await authService.apiCall(`${BASE_URL}/${url}`, {
            ...options,
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export async function fetchAllDataApiCoso(): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/coso`, {method:"GET"});
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    return response.json();
  } catch (error) {
    throw new Error('Failed to fetch data');
  }
}



export async function fetchAllDataApiNist(): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/nist`, {method:"GET"});
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    return response.json();
  } catch (error) {
    throw new Error('Failed to fetch data');
  }
}


export async function fetchDataApiRefrence(url: string, options: RequestInit = {}): Promise<any> {
    try {
        const response = await authService.apiCall(`${BASE_URL}/${url}`, {
            ...options,
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}
export async function fetchDataApiRisk(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/${url}`, {
      ...options,
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
}


export async function getControl(controlId: string): Promise<any> {
    try {
      const response = await authService.apiCall(`${BASE_URL}/controls/${controlId}`, {
        method: "GET",
      });
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
}



export async function updateControlApi(id: any, data: any ): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/controls/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
    
    if (!response.ok) {
      throw new Error('Failed to update control');
    }
    
    return response.json();
  } catch (error) {
    throw new Error(`Failed to update control: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
}

// Update basic control fields (name, description, objective, type)
export async function updateControlBasic(
  controlId: string | number,
  payload: { name?: string; description?: string; objective?: string; type?: string }
): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/controls/update-basic/${controlId}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    if (!response.ok || (data && data.success === false)) {
      if (response.status === 401 || response.status === 403 || (data && data.message === 'Forbidden access')) {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error('Failed to update control basic info');
    }

    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to update control basic info');
  }
}
export async function fetchAllDataApiJopTitle(): Promise<any> {
    try {
        const response = await authService.apiCall(`${BASE_URL}/jobTitles/getAll`, {
            method: "GET",
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export async function fetchAllDataApiSystem(): Promise<any> {
    try {
        const response = await authService.apiCall(`${BASE_URL}/systems/getAll`, {
            method: "GET",
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export async function fetchAllDataApiProcess(): Promise<any> {
    try {
        const response = await authService.apiCall(`${BASE_URL}/processes/getAll`, {
            method: "GET",
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}
export async function fetchAllDataApiAssertion(): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/assertion`, {method:"GET"});
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    return response.json();
  } catch (error) {
    throw new Error('Failed to fetch data');
  }
}

export async function fetchAllDataApiCobit(): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/cobit`, {method:"GET"});
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    return response.json();
  } catch (error) {
    throw new Error('Failed to fetch data');
  }
}

export async function fetchAllDataApiIso(): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/iso`, {method:"GET"});
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
       return response.json();
   } catch (error) {
    throw new Error('Failed to fetch data');
  }
}



export async function createAssertionFromControlApi(body: any): Promise<void> {
    try {
        const response = await authService.apiCall(`${BASE_URL}/assertion/fromControl`, {
            method: "POST",
            body: JSON.stringify(body),
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to create");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}



export async function createStandard(payload: { name: string; description?: string }) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/control-references`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    if (!response.ok || data?.success === false) {
      throw new Error(data?.message || 'Failed to create standard');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to create standard');
  }
}

export async function updateStandard(id: string, payload: { name?: string; description?: string }) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/control-references/${id}`, {
      method: "PATCH",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    if (!response.ok || data?.success === false) {
      throw new Error(data?.message || 'Failed to update standard');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to update standard');
  }
}

export async function deleteStandard(id: string) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/control-references/${id}`, {
      method: "DELETE",
    });
    const data = await response.json();
    if (!response.ok || data?.success === false) {
      throw new Error(data?.message || 'Failed to delete standard');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to delete standard');
  }
}


